import { createSlice } from "@reduxjs/toolkit";
import { fetchBranchList, createOrUpdateBranch, deleteOrRestoreBranch } from "./branchThunks";

const branchSlice = createSlice({
  name: "branchManage",
  initialState: {
    branchList: [],
    loading: false,
    error: null,
    selectedBranch: null,
    isEdit: false,
  },
  reducers: {
    setSelectedBranch: (state, action) => {
      state.selectedBranch = action.payload;
    },
    setIsEditBranch: (state, action) => {
      state.isEdit = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchList.pending, (s) => { s.loading = true; })
      .addCase(fetchBranchList.fulfilled, (s, a) => {
        s.loading = false; s.branchList = a.payload;
      })
      .addCase(fetchBranchList.rejected, (s, a) => {
        s.loading = false; s.error = a.payload;
      })
      .addCase(createOrUpdateBranch.fulfilled, (s) => { s.loading = false; })
      .addCase(deleteOrRestoreBranch.fulfilled, (s) => { s.loading = false; });
  },
});

export const { setSelectedBranch, setIsEditBranch } = branchSlice.actions;
export default branchSlice.reducer;
